/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RemoveStaffMemberMutationResponse, RemoveStaffMemberPathParams, RemoveStaffMember400, RemoveStaffMember401, RemoveStaffMember403, RemoveStaffMember404, RemoveStaffMember409, RemoveStaffMember500 } from "../../types/staffController/RemoveStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { removeStaffMember } from "../../client/staffController/removeStaffMember.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const removeStaffMemberMutationKey = () => [{ url: '/api/organizations/:organizationId/staff/:staffId' }] as const

export type RemoveStaffMemberMutationKey = ReturnType<typeof removeStaffMemberMutationKey>

export function removeStaffMemberMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = removeStaffMemberMutationKey()
        return mutationOptions<RemoveStaffMemberMutationResponse, ResponseErrorConfig<RemoveStaffMember400 | RemoveStaffMember401 | RemoveStaffMember403 | RemoveStaffMember404 | RemoveStaffMember409 | RemoveStaffMember500>, {organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, staffId }) => {
            return removeStaffMember(organizationId, staffId, config)
          },
        })

}

/**
 * @summary Remove staff member
 * {@link /api/organizations/:organizationId/staff/:staffId}
 */
export function useRemoveStaffMember<TContext>(options: 
{
  mutation?: UseMutationOptions<RemoveStaffMemberMutationResponse, ResponseErrorConfig<RemoveStaffMember400 | RemoveStaffMember401 | RemoveStaffMember403 | RemoveStaffMember404 | RemoveStaffMember409 | RemoveStaffMember500>, {organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? removeStaffMemberMutationKey()

          const baseOptions = removeStaffMemberMutationOptions(config) as UseMutationOptions<RemoveStaffMemberMutationResponse, ResponseErrorConfig<RemoveStaffMember400 | RemoveStaffMember401 | RemoveStaffMember403 | RemoveStaffMember404 | RemoveStaffMember409 | RemoveStaffMember500>, {organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"]}, TContext>
          

          return useMutation<RemoveStaffMemberMutationResponse, ResponseErrorConfig<RemoveStaffMember400 | RemoveStaffMember401 | RemoveStaffMember403 | RemoveStaffMember404 | RemoveStaffMember409 | RemoveStaffMember500>, {organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RemoveStaffMemberMutationResponse, ResponseErrorConfig<RemoveStaffMember400 | RemoveStaffMember401 | RemoveStaffMember403 | RemoveStaffMember404 | RemoveStaffMember409 | RemoveStaffMember500>, {organizationId: RemoveStaffMemberPathParams["organizationId"], staffId: RemoveStaffMemberPathParams["staffId"]}, TContext>
      
}